import React from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';

function GameName({ game, isOneLine, handlePlayerInteraction }) {
  const gameNameCssClasses = ClassNames('game-card-name game-name-title', {
    'game-name-oneline': isOneLine
  });
  return (
    <React.Fragment>
      {handlePlayerInteraction ? (
        <div
          data-testid='game-tile-game-name'
          className={gameNameCssClasses}
          title={game.name}
          onClick={handlePlayerInteraction}
          role='button'
          aria-hidden>
          {game.name}
        </div>
      ) : (
        <div data-testid='game-tile-game-name' className={gameNameCssClasses} title={game.name}>
          {game.name}
        </div>
      )}
    </React.Fragment>
  );
}

GameName.defaultProps = {
  isOneLine: false,
  handlePlayerInteraction: null
};

GameName.propTypes = {
  game: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  isOneLine: PropTypes.bool,
  handlePlayerInteraction: PropTypes.func
};

export default GameName;
